import { lazy } from "react";

// Dynamic import map for React components only
const reactPDFMap = {
  PDFViewer: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.PDFViewer })),
  Document: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.Document })),
  Page: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.Page })),
  Text: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.Text })),
  View: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.View })),
  Image: () =>
    import("@react-pdf/renderer").then((mod) => ({ default: mod.Image })),
  PDFDownloadLink: () =>
    import("@react-pdf/renderer").then((mod) => ({
      default: mod.PDFDownloadLink,
    })),
};

// Usage
export const lazyLoadReactPDF = (componentName) => {
  if (!Object.prototype.hasOwnProperty.call(reactPDFMap, componentName)) {
    throw new Error(`Unknown react-pdf component: "${componentName}"`);
  }
  return lazy(reactPDFMap[componentName]);
};